import { Perk } from '../hooks/context/Perks.model';
import { isFutureDate } from '../util/Date';
import { DateTime } from 'luxon';
import { MerchantDetails } from 'olo-service';
import { i18nInstance } from '../i18n';

export function isScheduledPerk(perk: Perk, merchant: MerchantDetails) {
    return perk.startsAt && merchant ? isFutureDate(perk.startsAt, merchant.timezone) : false;
}

export const generateScheduledPerkContent = (perk: Perk, merchant: MerchantDetails) => {
const { t } = i18nInstance;
  const perkStartsAt = perk.startsAt && DateTime.fromMillis(parseInt(perk.startsAt), { zone: merchant?.timezone }).toFormat('LLL dd');
  const perkEndsAt = perk.endsAt && DateTime.fromMillis(parseInt(perk.endsAt), { zone: merchant?.timezone }).toFormat('LLL dd');

  if (isScheduledPerk(perk, merchant)) {
    return `${t('perks.startsAt')} ${perkStartsAt}`;
  } else {
    return perkEndsAt && `${t('perks.endsAt')} ${perkEndsAt}`;
  }
};
